<template>
    <div class="add-btn lr-img-scale"
         :class="{'lottie-wrap-hide': hideCollectSuccessAnim }"
         @mouseenter="startAnimation"
         @mouseleave="stopAnimation"
    >
        <div class="lottie-wrap">
            <lottie v-show="!isCollection"
                    :options="addOptions"
                    :height="24"
                    :width="24"
                    @animCreated="collectAnimationCeratedHandler"
            />
            <lottie v-show="isCollection"
                    :options="addSuccessOptions"
                    :height="24"
                    :width="24"
                    @animCreated="collectSuccessAnimationCeratedHandler"
            />
        </div>
        <p>{{ langTransfer(isCollection && hideCollectSuccessAnim?'已收藏':'收藏') }}</p>
    </div>
</template>

<script>
    import * as animationDataAdd from '@/assets/lottie-json/add.json'
    import * as animationDataAddSuccess from '@/assets/lottie-json/addsuccess.json'

    export default {
        name: 'LottieAddBtn',
        props: {
            isCollection: {
                type: Boolean,
                default: undefined
            }
        },
        data () {
            return {
                addOptions: {
                    animationData: animationDataAdd.default,
                    loop: false,
                    autoplay: false
                },
                addSuccessOptions: {
                    animationData: animationDataAddSuccess.default,
                    loop: false,
                    autoplay: false
                },
                collectAnim: undefined,
                collectSuccessAnim: undefined,
                hideCollectSuccessAnim: false
            }
        },
        watch: {
            isCollection: {
                immediate: true,
                handler (newVal, oldVal) {
                    if (!this.collectSuccessAnim) {
                        return
                    }
                    if (newVal) {
                        if (typeof oldVal === 'undefined') {
                            this.hideCollectSuccessAnim = true
                            return
                        }
                        this.collectSuccessAnim.play()
                    } else {
                        this.collectSuccessAnim.stop()
                        this.hideCollectSuccessAnim = false
                    }
                }
            }
        },
        created () {
        },
        mounted () {
        },
        methods: {
            collectAnimationCeratedHandler (anim) {
                this.collectAnim = anim
            },
            collectSuccessAnimationCeratedHandler (anim) {
                this.collectSuccessAnim = anim
                this.collectSuccessAnim.addEventListener('complete', () => {
                    setTimeout(() => {
                        this.hideCollectSuccessAnim = true
                    }, 300)
                })
            },
            startAnimation () {
                if (this.isCollection) {
                    return
                }
                this.collectAnim.play()
            },
            stopAnimation () {
                if (this.isCollection) {
                    return
                }
                this.collectAnim.stop()
            }
        }
    }
</script>

<style scoped lang="less">
    .add-btn {
        width: 240px;
        height: 36px;
        background: #303133;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 18px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #FFFFFF;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        user-select: none;

        .lottie-wrap {
            width: 24px;
            overflow: hidden;
            margin-left: 91px;

            div {
                margin: 0 !important;
            }

        }
    }

    .lottie-wrap-hide {
        background: #606266;

        .lottie-wrap {
            width: 0;
            transition: width .4s;
            margin-right: 9px;
        }
    }
</style>
